<template>
  <div class="nav-bar">
    <div class="d-flex align-items-center pt-3 pb-3">
      <div class="py-0" align-self="center" @click="$.emit('ClosePick')">
        <div class="back">
          <i class="pi pi-arrow-left pe-3"></i>
          <span>Back To Listing</span>
        </div>
      </div>
      <div class="d-flex align-items-start ps-5">
        <div class="main-header-store">{{ DataValues.StoreType }}</div>
        <div>
          <p class="common-heading1 pt-1">{{ DataValues.StoreName }}</p>
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center">
      <div class="store" v-if="readyForDelivery">
        <p class="common-heading1">{{ DataObj.TotalSelected }}</p>
        <p class="storecode">{{ $t("PickList.picked") }}</p>
      </div>
      <div class="ps-5">
        <!-- <Button class="float-end" label="Print" icon="pi pi-print" /> -->
        <!-- <AddButton btnname="Confirm & Proceed" type="submit" id="ItemAdd" @click="SubmitFunc()" /> -->
        <!-- <AddButton :btnname="btnName" @click="nextPage" type="submit" id="ItemAdd" /> -->
        <Footer class="pb-3" :label="btnName" @save="nextPage" @cancel="DataObj.ConfirmModel = false"
          :cancelhide="false" :loading="SaveLoader" />
      </div>
    </div>
  </div>
  <b-container>
    <div class="storeName d-flex mt-5" v-if="readyForDelivery">
      <div class="d-flex">
        <div class="main-header-store1" :class="{ selected: CheckUser('all') }" @click="selectTab('all')">
          All
        </div>
      </div>
      <div class="d-flex" v-for="(item, index) in UserList" :key="index">
        <div class="main-header-store1" :title="item.PickedByName" :class="{ selected: CheckUser(item.PickedBy) }"
          @click="selectTab(item.PickedBy)">
          {{ item.ShortName }}
        </div>
      </div>
    </div>
    <div class="readyTableView mt-3" v-if="readyForDelivery">
      <div class="time d-flex">
        <div class="headings d-flex">
          <div class="text">
            <p class="storecode2">Avg pickup Time:</p>
          </div>
          <div class="value ms-2">
            <p class="value">{{ DataObj.AvgPickTime }}</p>
          </div>
          <p class="ms-3 me-3">|</p>
        </div>
        <div class="headings d-flex">
          <div class="text">
            <p class="storecode2">Avg value</p>
          </div>
          <div class="value ms-2">
            <p class="value">{{ DataObj.AvgValue.toFixed(2) }}</p>
          </div>
          <p class="ms-3 me-3">|</p>
        </div>
        <div class="headings d-flex">
          <div class="text">
            <p class="storecode2">Avg.QTY</p>
          </div>
          <div class="value ms-2">
            <p class="value">{{ DataObj.AvgQty.toFixed(2) }}</p>
          </div>
        </div>
      </div>
      <Tableview :rowHover="true" filterDisplay="menu" responsiveLayout="scroll" :columns="readyheaders"
        v-model:value="ReadyItemList" selectedProduct="single">
        <template v-slot:filter>
          <i class="pi pi-filter tablefilter ms-3 me-3"></i>
        </template>
        <template v-slot:Brandmodelsize="{ data }">
          <span>
            <template v-if="data.BrandName">{{ data.BrandName }}</template>
            <template v-if="data.BrandName && data.ModelNumberName">/</template>
            <template v-if="data.ModelNumberName">{{
              data.ModelNumberName
            }}</template>
            <template v-if="(data.BrandName || data.ModelNumberName) && data.SizeName">/</template>
            <template v-if="data.SizeName">{{ data.SizeName }}</template>
          </span>
        </template>
        <template v-slot:StockInHandSlot="{ data }">
          {{ data.StockInHand }}
        </template>
        <template v-slot:ExpiryDate="{ data }">
          {{
            data.ExpiryDate == "01-01-0001" || data.ExpiryDate == "01-01-1900"
              ? "-"
              : data.ExpiryDate
          }}
        </template>
        <template v-slot:BatchNo="{ data }">
          {{
            data.BatchNo == "" || data.BatchNo == null
              ? "-"
              : data.BatchNo
          }}
        </template>
        <template v-slot:BinLocation="{ data }">
          {{
            data.RoomName +
            " " +
            data.RackName +
            " " +
            data.RowName +
            " " +
            data.BoxName
          }}
        </template>
      </Tableview>
    </div>

    <div class="table" v-else>
      <b-form>
        <b-row>
          <b-col lg="1" md="1" sm="1" cols="1">
            <div :class="DataObj.ScanActive">
              <i class="pi pi-qrcode" @click="
                DataObj.ScanActive == 'barcodebg'
                  ? (DataObj.ScanActive = 'activebarcodebg')
                  : (DataObj.ScanActive = 'barcodebg')
                "></i>
            </div>
          </b-col>
          <b-col lg="4" md="3" sm="6" cols="8">
            <div class="field position-relative">
              <div v-if="DataObj.ScanActive == 'activebarcodebg'">
                <TextField label="Item Name" v-model="DataObj.Item" type="text" :rules="{}" placeholder="Choose Item"
                  clearable name="Item" id="Item" @keyupenter="onScanEnter" :required-icon="true"
                  :disabled="DataObj.ItemNameDisabled" />
              </div>
              <div v-else>
                <label>Item Name</label>

                <AutoCompleteCustom v-model="DataObj.Item" :items="DataObj.ItemOption" @keyup="LoadItem"
                  class="autoItem" @item-select="onScanEnter" name="ItemName" id="ItemName" />
              </div>
              <InputSwitch v-model="DataObj.Checked" class="itemdata-checked" @change="onCheckedChange" />
            </div>
          </b-col>
          <b-col lg="1" md="2" sm="6" cols="8">
            <div class="field">
              <TextField label="Avl Qty" v-model="DataObj.AvailableQuantity" type="text"
                :rules="{ numeric: true, required: true }" placeholder="" clearable name="AvailableQuantity"
                id="AvailableQuantity" :disabled="true" :required-icon="true" />
            </div>
          </b-col>
          <b-col lg="1" md="2" sm="6" cols="8">
            <div class="field">
              <TextField label="Pick Qty" v-model="DataObj.PickQuantity" type="text"
                :rules="{ numeric: true, required: true }" placeholder="" clearable name="PickQuantity"
                id="PickQuantity" :required-icon="true" :disabled="true" />
            </div>
          </b-col>
          <b-col lg="1" md="2" sm="6" cols="8">
            <div class="field">
              <TextField label="Scan Qty" v-model="DataObj.ScanQty" type="text"
                :rules="{ numeric: true, required: true }" placeholder="" clearable name="ScanQty" id="ScanQty"
                :required-icon="true" :disabled="DataObj.Checked ? true : false" @keyup="CheckAvaiQuantity" />

            </div>
          </b-col>

          <b-col lg="2" md="3" sm="6" cols="8" class="d-flex align-items-center">
            <AddButton class="btn-class-name" :btnname="AddItemBtnName" @click="AddItems" />
            <Cancel @canclebtn="ClearForm()" btnname="Clear" />
          </b-col>
          <b-col lg="2" md="3" sm="6" cols="8" class="d-flex align-items-center flex-row-reverse">
            <div class="selectedcountbg">
              <p class="selectedcount">{{ DataObj.ScannedList }}</p>
              <p class="selectedtext">Items Remaining</p>
            </div>
          </b-col>
        </b-row>
      </b-form>
      <Tableview :rowHover="true" filterDisplay="menu" responsiveLayout="scroll" :columns="headers"
        v-model:value="selectedProduct" selectedProduct="single" @updatedata="Itemschanges">
        <template v-slot:filter>
          <i class="pi pi-filter tablefilter ms-3 me-3"></i>
        </template>
        <template v-slot:Brandmodelsize="{ data }">
          <span>
            <template v-if="data.BrandName">{{ data.BrandName }}</template>
            <template v-if="data.BrandName && data.ModelNumberName">/</template>
            <template v-if="data.ModelNumberName">{{
              data.ModelNumberName
            }}</template>
            <template v-if="(data.BrandName || data.ModelNumberName) && data.SizeName">/</template>
            <template v-if="data.SizeName">{{ data.SizeName }}</template>
          </span>
        </template>
        <template v-slot:BinLocation="{ data }">
          {{
            data.RoomName +
            " " +
            data.RackName +
            " " +
            data.RowName +
            " " +
            data.BoxName
          }}
        </template>
        <template v-slot:ExpiryDate="{ data }">
          {{
            data.ExpiryDate == "01-01-0001" || data.ExpiryDate == "01-01-1900"
              ? "-"
              : data.ExpiryDate
          }}
        </template>
        <template v-slot:BatchNo="{ data }">
          {{
            data.BatchNo == "" || data.BatchNo == null
              ? "-"
              : data.BatchNo
          }}
        </template>
        <template v-slot:StockInHandSlot="{ data }">
          {{ data.StockInHand }}
        </template>

        <template v-slot:UOMName="{ data }">
          {{ data.UOMName }}
        </template>
        <template v-slot:ItemName="{ data }">
          <div class="d-flex">
            <i class="pi pi-check" :class="data?.IsScanned == 2 ? 'complete' : 'partial'"
              v-if="data?.IsScanned"></i><span :title="data.ItemName + ' - ' + data.BarCode">{{
                " " + data.ItemName + "-" + data.BarCode
              }}</span>
          </div>
        </template>
        <template v-slot:BarCodeSlot="{ data }">
          <span :title="data.BarCode">{{
            data.BarCode
          }}</span>
        </template>
        <template v-slot:action="{ data }">
          <span>
            <DeleteIcon @click="IsItemDelete(data)" />
          </span>
          <span v-if="data.IsScanned !== 0">
            <EditIcon @click="IsItemEdit(data)" />
          </span>
        </template>
        <!-- <template v-slot:Room="{ data }">
                    <span>
                        <CustomDropdown :items="DataObj.RoomOption" v-model="data.RoomId"
                            @update:modelValue="getrackbyroomid(data.RoomId)">
                        </CustomDropdown>
                    </span>
                </template>
                <template v-slot:Rack="{ data }">
                    <span>
                        <CustomDropdown :items="DataObj.RackOption" v-model="data.RackId"
                            @update:modelValue="getrowbyrackid(data.RackId)">
                        </CustomDropdown>
                    </span>
                </template>
                <template v-slot:Row="{ data }">
                    <CustomDropdown :items="DataObj.RowOption" v-model="data.RowId"
                        @update:modelValue="getboxbyrowid(data.RowId)">
                    </CustomDropdown>
                </template>
                <template v-slot:Box="{ data }">
                    <CustomDropdown :items="DataObj.BoxOption" v-model="data.BoxId">
                    </CustomDropdown>
                </template> -->
        <template v-slot:PickQty="{ data, rowIndex }">
          <TextField :rules="{ required: false }" :required-icon="false" :name="`'PickQty'${rowIndex}`"
            :id="`'PickQty'${rowIndex}`" v-model="data.ItemQuantity" />
        </template>
        <template v-slot:Reason="{ data, rowIndex }">
          <TextField :rules="{ required: true }" :required-icon="false" :name="`'Reason'${rowIndex}`"
            :id="`'Reason'${rowIndex}`" v-model="data.PickReason" />
        </template>
        <template v-slot:Remarks="{ data, rowIndex }">
          <TextField :rules="{ required: false }" :required-icon="false" :name="`'Remarks'${rowIndex}`"
            :id="`'Remarks'${rowIndex}`" v-model="data.Remarks" />
        </template>
      </Tableview>
    </div>
  </b-container>
  <Toast />
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <EditConfirmation :Editmodel="DataObj.AddConfirm" @yes="AddItems" @no="DataObj.AddConfirm = false"
    content="Scanned Quantity less than Pick Quantity.Are you sure want to add?" />
  <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues"
    :PrintType="PrintType" />
  <Dialog class="" :modal="true" v-model:visible="DataObj.EditModel" :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '40vw' }" header="" @after-hide="$.emit('close')">
    <template #header>
      <h4>{{ $t("PickList.discrepancyPop") }}</h4>
    </template>
    <span class="light-txt">{{ $t("PickList.committedItem") }}</span>
    <Tableview :rowHover="true" filterDisplay="menu" responsiveLayout="scroll" :columns="DiscrepancyHeader"
      v-model:value="DiscrepancyItem" selectedProduct="single">
      <template v-slot:BinLocation="{ data }">
        {{
          (data.RoomName || "") +
          " " +
          (data.RackName || "") +
          " " +
          (data.RowName || "") +
          " " +
          (data.BoxName || "")
        }}
      </template>
    </Tableview>
    <span class="light-txt">{{ $t("PickList.pickedItem") }}</span>
    <Tableview :rowHover="true" filterDisplay="menu" responsiveLayout="scroll" :columns="PickedHeader"
      v-model:value="pickedItem" selectedProduct="single">
    </Tableview>
    <div class="d-flex">
      <span>{{ $t("PickList.confirmIssue") }}</span>
      <Footer class="pb-3" @save="ConfirmIssue" label="Confirm" @cancel="DataObj.EditModel = false" />
    </div>
  </Dialog>
  <Dialog class="" :modal="true" v-model:visible="DataObj.ConfirmModel"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '40vw' }" header=""
    @after-hide="$.emit('close')">
    <template #header>
      <h1>{{ $t("PickList.confirmPop") }}</h1>
    </template>
    <span class="light-txt">{{
      confirmItem.length + " " + $t("PickList.missingContent")
    }}</span>
    <Tableview :rowHover="true" filterDisplay="menu" responsiveLayout="scroll" :columns="PickedHeader"
      v-model:value="confirmItem" selectedProduct="single">
      <template v-slot:BinLocation="{ data }">
        {{
          data.RoomName ||
          "" + " " + data.RackName ||
          "" + " " + data.RowName ||
          "" + " " + data.BoxName ||
          "" ||
          ""
        }}
      </template>
    </Tableview>

    <div class="d-flex">
      <Footer class="pb-3" @save="ConfirmProceed" label="Add" @cancel="DataObj.ConfirmModel = false" />
    </div>
  </Dialog>
</template>
<script lang="ts">
import { defineComponent, ref, onMounted, computed, watch } from "vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";
import Tableview from "../../../../../../components/FormComponents/NormalTable.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import { useI18n } from "vue-i18n";
import CustomDropdown from "../../../../../../components/FormComponents/Dropdown.vue";
import ItemStoreMappingService from "../../../../Service/ItemStoreMappingService";
import RackService from "../../../../../../modules/Inventory/Service/RackService";
import RowService from "../../../../../../modules/Inventory/Service/RowService";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import { useToast } from "primevue/usetoast";
import { useRoute, useRouter } from "vue-router";
import moment from "moment";
import Service from "../../../../../../modules/Inventory/Service/StockOutService";
import commonService from "../../../../Service/StockInService";
import CreateSuccessully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import CrystalReportPrintPopUp from "../../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";
import WithoutStockService from "../../../../../../modules/Inventory/Service/WithoutStockAffectService";
import Itemservice from "../../../../../../modules/Inventory/Service/ItemMasService";
import { useForm } from "vee-validate";
import Footer from "../../../../../../components/FormComponents/Footer.vue";
import AutoCompleteCustom from "../../../../../../components/FormComponents/AutoComplete.vue";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import { setupHistoryManagement } from "../../../../../../modules/Inventory/Service/HistoryManage";
import EditIcon from "../../../../../../components/GeneralButtons/EditIcon.vue";
import Divider from "primevue/divider";
import Cancel from "../../../../../../components/GeneralButtons/CancelButtton.vue";

export default defineComponent({
  components: {
    BacktoPage,
    Tableview,
    CustomDropdown,
    TextField,
    UpdatedSuccessfully,
    CreateSuccessully,
    CrystalReportPrintPopUp,
    Footer,
    AutoCompleteCustom,
    EditConfirmation,
    Cancel
  },
  props: {
    ItemList: {
      type: Array,
      default: [],
    },
    DataValues: {
      type: Object,
      default: {},
    },
    requestForm: {
      type: Object,
      default: {},
    },
  },
  setup(props) {
    const btnName = ref("Confirm & Proceed");

    const { t } = useI18n();
    const items: any = ref(props.ItemList);
    const toast = useToast();
    const { handleSubmit, errors, resetForm, resetField } = useForm();

    const route = useRoute();
    let session: any = localStorage.getItem("UsersData");
    let SaveLoader = ref(false);
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    let IsAdmin = Number(session.Admin);

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    const successpop = ref(false);
    const updatepop = ref(false);
    const Editmodel = ref(false);
    const router = useRouter();
    const CrystalReportPopup = ref(false);
    // let RequestId: any = route.query.requestId;
    // let StockWOTransTMIdQuery: any = route.query.StockWOTransTMId;

    let QueryStringValue2: any = route.query;
    QueryStringValue2 = JSON.parse(QueryStringValue2.data);

    const selectedTab: any = ref(["all"]);

    const AddItemBtnName = ref("Add");

    const headers = [
      {
        header: "Category",
        field: "ItemCategory1",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Code",
        field: "ItemProductId",
        class: "smallwidth",
        bodyclass: "boldclass",
      },
      {
        header: "Name",
        field: "ItemName",
        slot: "ItemName",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: "BarCode",
        field: "BarCode",
        slot: "BarCodeSlot",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: "Exp date",
        field: "ExpiryDate",
        slot: "ExpiryDate",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: "Batch.No",
        field: "BatchNo",
        slot: "BatchNo",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: "UOM",
        field: "UOMName",
        slot: "UOMName",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },

      {
        header: "Bin Location",
        field: "RoomName",
        slot: "BinLocation",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },

      {
        header: "Avl Qty",
        field: "StockInHand",
        slot: "StockInHandSlot",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
        bodyclass: "right_td",
      },
      // {
      //   header: "Picked Qty",
      //   field: "PickedQty",
      //   filterTemplate: "MultiSelect",
      //   class: "smallwidth",
      //   bodyclass: "right_td",
      //   ShowMactchMode: false,
      // },
      // {
      //   header: "InTransist Qty",
      //   field: "InTransist",
      //   filterTemplate: "MultiSelect",
      //   class: "smallwidth",
      //   bodyclass: "right_td",
      //   ShowMactchMode: false,
      // },
      {
        header: "Issued Qty",
        field: "IssuedQuantity",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
        bodyclass: "right_td",
      },
      {
        header: "Pick Qty",
        field: "ApprovedQty",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
        bodyclass: "right_td",
      },
      {
        header: "Scan Qty",
        field: "ScanQty",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
        bodyclass: "right_td",
      },
      {
        header: "Reason",
        field: "PickReason",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      {
        header: "Remarks",
        field: "Remarks",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.outboundrequestdetails.Brand/Model/Size"),
        field: "",
        slot: "Brandmodelsize",
        fieldDisplay: "false",
        bodyclass: "text_overflow1",
      },
      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "last-column-position",
        fieldDisplay: "false",
      },
      // {
      //     header: "Pick Qty",
      //     field: "PickQty",
      //     slot: 'PickQty',
      //     fieldDisplay: "false",
      //     filterTemplate: "MultiSelect",
      //     ShowMactchMode: false,
      // },
      // {
      //     header: "Reason",
      //     field: "Reason",
      //     slot: 'Reason',
      //     fieldDisplay: "false",
      //     filterTemplate: "MultiSelect",
      //     ShowMactchMode: false,
      // },
      // {
      //     header: "Remarks",
      //     field: "Remarks",
      //     slot: 'Remarks',
      //     fieldDisplay: "false",
      //     filterTemplate: "MultiSelect",
      //     ShowMactchMode: false,
      // },
    ];
    const DiscrepancyHeader = [
      {
        header: "Item Name",
        field: "ItemName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "UOM",
        field: "UOMName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Batch No",
        field: "BatchNo",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "BarCode No",
        field: "BarCodeNo",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },

      {
        header: "Pick Qty",
        field: "PickQuantity",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Bin Location",
        field: "RoomName",
        slot: "BinLocation",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
    ];
    const PickedHeader = [
      {
        header: "Item Name",
        field: "ItemName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "UOM",
        field: "UOMName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Batch No",
        field: "BatchNo",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "BarCode No",
        field: "BarCodeNo",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },

      {
        header: "Pick Qty",
        field: "PickQuantity",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Bin Location",
        field: "RoomName",
        slot: "BinLocation",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
    ];

    const globalFilterFields = ref(headers.map((col) => col.field));
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      TaxName: { value: null, matchMode: FilterMatchMode.IN, options: items },
      TaxType: { value: null, matchMode: FilterMatchMode.IN, options: items },
      TaxSubType: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      ActiveStatus: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
    };
    const DataObj = ref({
      RoomOption: [],
      RackOption: [],
      RowOption: [],
      BoxOption: [],
      AvgPickTime: ref(),
      AvgValue: ref(),
      AvgQty: ref(),
      TotalSelected: ref(),
      Item: ref(),
      AvailableQuantity: ref(),
      PickQuantity: ref(),
      ScanQty: ref(),
      BarCode: 0,
      Checked: false,
      EditModel: false,
      ConfirmModel: false,
      ItemOption: ref([]),
      ScanActive: "activebarcodebg",
      ScannedList: ref(),
      AddConfirm: false,
      ItemNameDisabled: false,
    });
    watch(
      () => DataObj.value.Checked,
      (newVal) => {
        if (DataObj.value.Item) {
          DataObj.value.ScanQty = newVal ? 1 : 0;
        }
      }
    );
    let selectedProduct: any = ref(props.ItemList);
    selectedProduct.value = selectedProduct.value.map((item) => {
      item.ApprovedQty = item.PickQuantity;
      item.ScanQty = 0;
      return item;
    });
    let selectedProductOrg: any = ref(
      JSON.parse(JSON.stringify(selectedProduct.value))
    );
    let ReadyItemList: any = ref([]);
    const createrequestForm = ref({
      IsNew: true,
      IsModified: true,
      IsDeleted: true,
      IsActive: true,
      CreatedAt: "2023-03-27T12:32:26.939Z",
      ModifiedAt: "2023-03-27T12:32:26.939Z",
      CreatedBy: 0,
      ModifiedBy: 0,
      CreatedByName: "",
      ApproverID: 0,
      TaskID: 0,
      IsApprovalRequired: true,
      ApprovalDate: "2023-03-27T12:32:26.939Z",
      TaskStatus: 0,
      TaskExpiryDate: "2023-03-27T12:32:26.939Z",
      TaskName: "",
      Taskpriority: 0,
      ResponseTimeInHours: 0,
      IsAutoApproval: true,
      IsApproved: 0,
      Id: 0,
      DocType: "",
      RefNo: "",
      DocNo: "",
      DocDate: "2023-03-27T12:32:26.939Z",
      StoreId: 0,
      FromStore: 0,
      ToStore: 0,
      DcNo: "",
      InvoiceNo: "",
      InWardNo: "",
      Type: "",
      Status: "",
      AuthorizedStatus: true,
      CancelReason: "",
      Cancelled: true,
      RefId: 0,
      Remarks: "",
      SubDetailsAmount: 0,
      TaxAmount: 0,
      DiscountAmount: 0,
      Amount: 0,
      ClosedReason: "",
      Closed: true,
      Subject: "",
      HospitalId: 0,
      BranchId: 0,
      GrnPaymentType: "",
      CrNoteAmt: 0,
      DueAmount: 0,
      PatientId: "2",
      VisitId: 3,
      TempPatientId: 1,
      EntityId: 0,
      EntityOperationId: 0,
      TimeTaken: "00:00:00",
      DeptRoleId: 0,
      RequestCreatedBy: 0,
      RequestCreatedBranch: 0,
      StoreBrMapId: 0,
      FromStoreBrMapId: 0,
      ToStoreBrMapId: 0,

      FromStoreBranchId: 0,
      ToStoreBranchId: 0,
    });

    const readyheaders = [
      {
        header: "HSN Code",
        field: "ItemProductId",
        class: "smallwidth",
      },
      {
        header: "Category",
        field: "ItemCategory1",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: "Code",
        field: "ItemProductId",
        class: "smallwidth",
        bodyclass: "boldclass",
      },
      {
        header: "Name",
        field: "Itemname1",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: "Exp date",
        field: "ExpiryDate",
        slot: "ExpiryDate",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      {
        header: "Batch.No",
        field: "BatchNo",
        slot: "BatchNo",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      {
        header: "UOM",
        field: "UOMName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },

      {
        header: "Bin Location",
        field: "RoomName",
        slot: "BinLocation",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },

      {
        header: "Avl Qty",
        field: "StockInHand",
        slot: "StockInHandSlot",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
        bodyclass: "right_td",
      },
      // {
      //   header: "Picked Qty",
      //   field: "PickedQty",
      //   filterTemplate: "MultiSelect",
      //   ShowMactchMode: false,
      //   class: "smallwidth",
      //   bodyclass: "right_td",
      // },
      // {
      //   header: "InTransist Qty",
      //   field: "InTransist",
      //   filterTemplate: "MultiSelect",
      //   ShowMactchMode: false,
      //   class: "smallwidth",
      //   bodyclass: "right_td",
      // },
      {
        header: "Issued Qty",
        field: "IssuedQuantity",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
        bodyclass: "right_td",
      },
      {
        header: "Scanned Qty",
        field: "ApprovedQty",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
        bodyclass: "right_td",
      },
      {
        header: "Issue Qty",
        field: "PickQuantity",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
        bodyclass: "right_td",
      },
      {
        header: "Reason",
        field: "PickReason",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "smallwidth",
      },
      {
        header: "Remarks",
        field: "Remarks",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.outboundrequestdetails.Brand/Model/Size"),
        field: "",
        slot: "Brandmodelsize",
        fieldDisplay: "false",
        bodyclass: "text_overflow1",
      },
    ];
    const readyForDelivery = ref(false);
    const UserList: any = ref([]);
    const ReadyListOrg: any = ref([]);
    const barcode = ref("");
    let DiscrepancyItem: any = ref([]);
    let pickedItem: any = ref([]);
    let confirmItem: any = ref([]);
    /*----Functions----*/
    onMounted(() => {
      debugger;
      // ConfirmProceed()
    });
    //Average Pick Time Calculation

    function parseDate(dateString: string): Date {
      const [date, time] = dateString.split(" ");
      const [day, month, year] = date.split("-").map(Number);
      const [hours, minutes, seconds] = time.split(":").map(Number);
      return new Date(year, month - 1, day, hours, minutes, seconds);
    }

    function calculateTimeSpent(start: Date, end: Date): number {
      return (end.getTime() - start.getTime()) / 1000; // Time spent in seconds
    }

    function formatTime(seconds: number): string {
      const hrs = Math.floor(seconds / 3600);
      const mins = Math.floor((seconds % 3600) / 60);
      const secs = Math.floor(seconds % 60);
      return `${String(hrs).padStart(2, "0")}:${String(mins).padStart(
        2,
        "0"
      )}:${String(secs).padStart(2, "0")}`;
    }
    // function computeAveragePickTime(records): string {
    //     //let totalTimeSpent = 0;

    //     records.forEach(record => {
    //         // const start = parseDate(record.PickStartTime);
    //         // const end = parseDate(record.PickEndTime);
    //         // const timeSpent = calculateTimeSpent(start, end);
    //         //totalTimeSpent += timeSpent;
    //     });

    //    // const averageTimeSpent = totalTimeSpent / records.length;
    //     //return formatTime(averageTimeSpent);
    // }
    // //Average Pick Time
    // DataObj.value.AvgPickTime = computed(() => {
    //     // let arr = ReadyItemList.value.map((item) => item.PickStartTime);
    //     // let data: any = computeAveragePickStartTime(arr);
    //       return computeAveragePickTime(ReadyItemList.value);
    //    // return ReadyItemList.value.length > 0 ? ReadyItemList.value[0].TimeTaken : '00:00:00'
    // });
    function computeAveragePickTime(records) {
      if (records.length === 0) {
        return "00:00:00";
      }

      let totalSeconds = 0;

      records.forEach((record) => {
        const timeParts = record.TimeTaken.split(":").map(Number);
        const seconds = timeParts[0] * 3600 + timeParts[1] * 60 + timeParts[2];
        totalSeconds += seconds;
      });

      const averageSeconds = totalSeconds / records.length;

      const hours = Math.floor(averageSeconds / 3600)
        .toString()
        .padStart(2, "0");
      const minutes = Math.floor((averageSeconds % 3600) / 60)
        .toString()
        .padStart(2, "0");
      const seconds = Math.floor(averageSeconds % 60)
        .toString()
        .padStart(2, "0");

      return `${hours}:${minutes}:${seconds}`;
    }

    // Average Pick Time
    DataObj.value.AvgPickTime = computed(() => {
      return computeAveragePickTime(ReadyItemList.value);
    });
    //Average Quantity
    DataObj.value.AvgQty = computed(() => {
      const totalPickQuantity = ReadyItemList.value.reduce(
        (total, item) => total + item.PickQuantity,
        0
      );
      const numberOfItems = ReadyItemList.value.length;
      return numberOfItems ? totalPickQuantity / numberOfItems : 0;
    });
    //Average Value
    DataObj.value.AvgValue = computed(() => {
      const totalValue = ReadyItemList.value.reduce(
        (total, item) => total + item.PickQuantity * item.UnitRate,
        0
      );
      const numberOfItems = ReadyItemList.value.length;
      return numberOfItems ? totalValue / numberOfItems : 0;
    });
    //Picked List Count
    DataObj.value.TotalSelected = computed(() => {
      let data = ReadyItemList.value.length + "/" + ReadyListOrg.value.length;
      return data;
    });
    //Scanned List Count
    DataObj.value.ScannedList = computed(() => {
      let scannedCount = selectedProduct.value.filter(
        (item) => item.IsScanned == 0
      );
      let data = scannedCount.length + "/" + selectedProduct.value.length;
      return data;
    });
    //Submit Function
    //Submit Function Validation
    async function SubmitFunc() {
      debugger;
      IsSubmit();
    }
    async function IsSubmit() {
      debugger;
      SaveLoader.value = true;

      let arr: any = [];
      let StockInTransId = 0;
      let QueryStringValue1: any = route.query;

      console.log(QueryStringValue1);
      QueryStringValue1 = QueryStringValue1.param;

      if (QueryStringValue1 == "DirectIssue") {
        createrequestForm.value.DocType = "10";
        createrequestForm.value.RefNo = "";
      } else if (QueryStringValue1 == "IndirectIssue") {
        createrequestForm.value.DocType = "11";
        createrequestForm.value.RefNo = props.requestForm.requestId;
      } else {
        createrequestForm.value.DocType = "13";
      }

      if (QueryStringValue2["type"] == 3) {
        createrequestForm.value.RefId = QueryStringValue2["StockTransId"];
      } else {
        createrequestForm.value.RefId = QueryStringValue2["StockWOTransTMId"];
      }
      createrequestForm.value.Id = QueryStringValue2["StockOutTransTMId"];

      createrequestForm.value.StoreId = props.requestForm.fromStoreId;
      createrequestForm.value.FromStore = props.requestForm.fromStoreId;
      createrequestForm.value.ToStore = props.requestForm.toStoreId;

      createrequestForm.value.FromStoreBrMapId =
        QueryStringValue2["ToStoreBrMapId"];
      createrequestForm.value.ToStoreBrMapId =
        QueryStringValue2["FromStoreBrMapId"];
      createrequestForm.value.StoreBrMapId =
        QueryStringValue2["ToStoreBrMapId"];

      createrequestForm.value.FromStoreBranchId =
        QueryStringValue2["ToStoreBranchId"];
      createrequestForm.value.ToStoreBranchId =
        QueryStringValue2["FromStoreBranchId"];

      createrequestForm.value.RefNo = props.requestForm.requestId;
      createrequestForm.value.DocNo = props.requestForm.issueId;
      createrequestForm.value.DocNo = props.requestForm.issueId;
      createrequestForm.value.CreatedAt = moment().format(
        "YYYY-MM-DDTHH:mm:ss.SSSZ"
      );
      createrequestForm.value.ModifiedAt = moment().format(
        "YYYY-MM-DDTHH:mm:ss.SSSZ"
      );
      createrequestForm.value.BranchId = QueryStringValue2["BranchId"];

      createrequestForm.value.HospitalId = HospitalId;
      createrequestForm.value.ModifiedBy = UserId;
      createrequestForm.value.CreatedBy = UserId;
      createrequestForm.value.EntityId = props.requestForm.EntityId;
      createrequestForm.value.EntityOperationId =
        props.requestForm.EntityOperationId;
      createrequestForm.value.DocDate = moment().format(
        "YYYY-MM-DDTHH:mm:ss.SSSZ"
      );

      createrequestForm.value.DeptRoleId = rolesData.DeptRoleMapId;

      let result: any;
      let id: any = 0;
      let msg: String = "";
      let HiddenStockOutMasterId: any = 0;

      if (
        (QueryStringValue2["type"] == 2 || QueryStringValue2["type"] == 3) &&
        QueryStringValue2["StockOutTransTMId"] != 0
      ) {
        result = await Service.updateStockOutMasterTM(createrequestForm.value);
        id = QueryStringValue2["StockOutTransTMId"];
      } else if (
        (QueryStringValue2["type"] == 2 &&
          QueryStringValue2["StockOutTransTMId"] == 0) ||
        QueryStringValue2["type"] == 1 ||
        (QueryStringValue2["type"] == 3 &&
          QueryStringValue2["StockTransId"] != 0)
      ) {
        result = await Service.creatStockOutMasterTM(createrequestForm.value);
        id = result["result"];
        HiddenStockOutMasterId = result["result"];
      } else {
        console.log(QueryStringValue2);
      }

      let message = result["ErrorInfo"].ErrorCode;

      if (message == null) {
        debugger;
        for (let i = 0; i < ReadyItemList.value.length; i++) {
          let obj = {};
          if (ReadyItemList.value[i]["PickQuantity"] > 0) {
            (obj["DocType"] = createrequestForm.value.DocType || 0),
              (obj["StoreId"] = createrequestForm.value.StoreId || 0),
              (obj["Id"] = ReadyItemList.value[i]["StockOutDetailId"] || 0),
              (obj["ItemId"] = ReadyItemList.value[i]["ItemId"]),
              (obj["Qty"] = ReadyItemList.value[i]["PickQuantity"]),
              (obj["RefId"] = id),
              (obj["Rate"] = ReadyItemList.value[i]["Rate"]);
            obj["UnitRate"] = ReadyItemList.value[i]["UnitRate"];
            obj["PurchaseTax"] = ReadyItemList.value[i]["PurchasePercentage"];
            obj["PurchaseTaxAmount"] =
              ReadyItemList.value[i]["Purchasetaxamount"];
            obj["SaleTax"] = ReadyItemList.value[i]["SalesPercentage"];
            (obj["SaleTaxAmount"] = ReadyItemList.value[i]["Salestaxamount"]),
              (obj["PackSizeId"] =
                ReadyItemList.value[i]["PackageSizeId"] || 0),
              (obj["HSNId"] = ReadyItemList.value[i]["HSNId"]),
              //  (obj["TaxId"] = 1),
              (obj["BarCodeNo"] = ReadyItemList.value[i]["BarCodeNo"] || 0),
              (obj["BarCode"] = ReadyItemList.value[i]["BarCode"] || "");
            // (obj["StockWoDetailId"] = ReadyItemList.value[i]["StockDetailsId"]),
            if (ReadyItemList.value[i]["ExpiryDate"]) {
              obj["ExpiryDate"] = moment(
                ReadyItemList.value[i]["ExpiryDate"],
                "DD-MM-YYYY"
              ).format("YYYY-MM-DD");
            } else {
              obj["ExpiryDate"] = "1900-01-01T19:17:58.632+05:30";
            }
            if (ReadyItemList.value[i]["ManufactureDate"]) {
              obj["ManufactureDate"] = moment(
                ReadyItemList.value[i]["ManufactureDate"],
                "DD-MM-YYYY"
              ).format("YYYY-MM-DD");
            } else {
              obj["ManufactureDate"] = "1900-01-01T19:17:58.632+05:30";
            }
            (obj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
              (obj["ModifiedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
              (obj["CreatedBy"] = UserId),
              (obj["ModifiedBy"] = UserId),
              (obj["UOM"] = ReadyItemList.value[i]["UOM"]),
              (obj["Brand"] =
                ReadyItemList.value[i]["Brand"] == null
                  ? 0
                  : ReadyItemList.value[i]["Brand"]),
              (obj["ModelNumber"] =
                ReadyItemList.value[i]["ModelNumber"] == null
                  ? 0
                  : ReadyItemList.value[i]["ModelNumber"]),
              (obj["Size"] =
                ReadyItemList.value[i]["Size"] == null
                  ? 0
                  : ReadyItemList.value[i]["Size"]);

            (obj["IsApproved"] = 0),
              (obj["ConsigneeItem"] =
                ReadyItemList.value[i]?.["ConsigneeItem"] || 0),
              (obj["CurrentStockInHand"] =
                ReadyItemList.value[i]["StockInHand"] || 0),
              (obj["IssueReason"] =
                ReadyItemList.value[i]?.["PickReason"] || ""),
              (obj["Remarks"] = ReadyItemList.value[i]["Remarks"] || "");
            (obj["PickedBy"] = ReadyItemList.value[i]?.["PickedBy"] || ""),
              (obj["PickStartTime"] = moment(
                ReadyItemList.value[i]["PickStartTime"],
                "DD-MM-YYYY HH:mm:ss"
              ).format("YYYY-MM-DDTHH:mm:ss.SSSZ"));
            obj["PickEndTime"] = moment(
              ReadyItemList.value[i]["PickEndTime"],
              "DD-MM-YYYY HH:mm:ss"
            ).format("YYYY-MM-DDTHH:mm:ss.SSSZ");
            obj["BatchNo"] = ReadyItemList.value[i]["BatchNo"] || "";

            arr.push(obj);
          }
        }

        let result = await Service.CreateBarcodeStockOut(arr);
        let msgMapping = result["ErrorInfo"].ErrorCode;
        debugger;

        if (msgMapping == null) {
          await UpdatePicks(4, 6, 1);
          createrequestForm.value.RefId = id;
          createrequestForm.value.RefNo = "";

          createrequestForm.value.StoreId = props.requestForm.toStoreId;
          createrequestForm.value.StoreBrMapId =
            QueryStringValue2["FromStoreBrMapId"];
          createrequestForm.value.BranchId =
            QueryStringValue2["FromStoreBranchId"];

          createrequestForm.value.RequestCreatedBy = Number(
            props.requestForm.RequestCreatedBy
          );
          createrequestForm.value.RequestCreatedBranch =
            QueryStringValue2["FromStoreBranchId"];

          if (
            (QueryStringValue2["type"] == 2 &&
              QueryStringValue2["StockOutTransTMId"] != 0) ||
            (QueryStringValue2["type"] == 3 &&
              QueryStringValue2["StockOutTransTMId"] != 0 &&
              QueryStringValue2["StockTransId"] != 0)
          ) {
            createrequestForm.value.Id = StockInTransId;
            createrequestForm.value.EntityId = 3050;
            createrequestForm.value.EntityOperationId = 3050002;
            result = await commonService.updateStockInTM(
              createrequestForm.value
            );
            id = StockInTransId;
          } else if (
            (QueryStringValue2["type"] == 2 &&
              QueryStringValue2["StockOutTransTMId"] == 0) ||
            QueryStringValue2["type"] == 1 ||
            (QueryStringValue2["type"] == 3 &&
              QueryStringValue2["StockTransId"] != 0 &&
              QueryStringValue2["StockOutTransTMId"] == 0)
          ) {
            createrequestForm.value.StoreId = props.requestForm.toStoreId;
            createrequestForm.value.BranchId =
              QueryStringValue2["FromStoreBranchId"];
            createrequestForm.value.EntityId = 3050;
            createrequestForm.value.EntityOperationId = 3050001;
            result = await commonService.createStockInTM(
              createrequestForm.value
            );
            id = result["result"];
          }
        }

        let message1 = result["ErrorInfo"].ErrorCode;

        if (message1 == null) {
          debugger;
          let arr1: any = [];
          for (let i = 0; i < ReadyItemList.value.length; i++) {
            let obj = {};
            if (ReadyItemList.value[i]["PickQuantity"] > 0) {
              (obj["Id"] = ReadyItemList.value[i]["StockInDetailsId"] ?? 0),
                (obj["ItemId"] = ReadyItemList.value[i]["ItemId"]),
                (obj["Qty"] = ReadyItemList.value[i]["PickQuantity"] || 0.0),
                (obj["POQty"] = ReadyItemList.value[i]["PickQuantity"] || 0.0),
                (obj["RefId"] = id),
                (obj["PackSizeId"] = ReadyItemList.value[i]["PackSizeId"] || 0),
                (obj["HSNId"] = ReadyItemList.value[i]["HSNId"] || 0),
                (obj["UnitMRP"] = ReadyItemList.value[i]["MRP"] || 0),
                (obj["CreatedAt"] = moment().format(
                  "YYYY-MM-DDTHH:mm:ss.SSSZ"
                )),
                (obj["ModifiedAt"] = moment().format(
                  "YYYY-MM-DDTHH:mm:ss.SSSZ"
                )),
                (obj["CreatedBy"] = UserId),
                (obj["ModifiedBy"] = UserId),
                (obj["Rate"] = ReadyItemList.value[i]["Rate"] || 0);
              obj["UnitRate"] = ReadyItemList.value[i]["UnitRate"] || 0;
              obj["PurchaseTax"] =
                ReadyItemList.value[i]["PurchasetaxPercentage"] || 0;
              (obj["UOM"] = ReadyItemList.value[i]["UOM"]),
                (obj["PurchaseTaxAmount"] =
                  ReadyItemList.value[i]["Purchasetaxamount"] || 0);
              obj["SalesTax"] =
                ReadyItemList.value[i]["SalestaxPercentage"] || 0;
              obj["SalesTaxAmount"] =
                ReadyItemList.value[i]["Salestaxamount"] || 0;
              obj["DiscountPer"] = ReadyItemList.value[i]["Discount"] || 0;
              obj["DiscountAmount"] =
                ReadyItemList.value[i]["DiscountAmount"] || 0;
              obj["TransportCharges"] =
                ReadyItemList.value[i]["transportcharges"] || 0;
              obj["ServiceCharges"] =
                ReadyItemList.value[i]["servicecharges"] || 0;
              obj["OtherCharges"] = ReadyItemList.value[i]["othercharges"] || 0;
              obj["BatchNo"] = ReadyItemList.value[i]["BatchNo"] || "";
              obj["TotalValue"] = ReadyItemList.value[i]["Totalvalue"] || 0;
              obj["RefBarCodeNo"] = ReadyItemList.value[i]["BarCodeNo"] || 0;
              obj["RefBarCode"] = ReadyItemList.value[i]["BarCode"] || 0;
              if (
                ReadyItemList.value[i]["ExpiryDate"] != "01-01-0001" &&
                ReadyItemList.value[i]["ExpiryDate"]
              ) {
                obj["ExpiryDate"] = moment(
                  ReadyItemList.value[i]["ExpiryDate"],
                  "DD-MM-YYYY"
                ).format("YYYY-MM-DD");
              } else {
                obj["ExpiryDate"] = "1900-01-01T19:17:58.632+05:30";
              }
              if (
                ReadyItemList.value[i]["ManufactureDate"] != "01-01-0001" &&
                ReadyItemList.value[i]["ManufactureDate"] != "01-01-1900" &&
                ReadyItemList.value[i]["ManufactureDate"]
              ) {
                obj["ManufactureDate"] = moment(
                  ReadyItemList.value[i]["ManufactureDate"],
                  "DD-MM-YYYY"
                ).format("YYYY-MM-DD");
              } else {
                obj["ManufactureDate"] = "1900-01-01T19:17:58.632+05:30";
              }
              (obj["Brand"] =
                ReadyItemList.value[i]["Brand"] == null
                  ? 0
                  : ReadyItemList.value[i]["Brand"]),
                (obj["ModelNumber"] =
                  ReadyItemList.value[i]["ModelNumber"] == null
                    ? 0
                    : ReadyItemList.value[i]["ModelNumber"]),
                (obj["Size"] =
                  ReadyItemList.value[i]["Size"] == null
                    ? 0
                    : ReadyItemList.value[i]["Size"]);

              (obj["IsApproved"] = 0), arr1.push(obj);
            }
          }

          let result1 = await commonService.createStockInDetails(arr1);
          let msgMapping1 = result1["ErrorInfo"].ErrorCode;
          if (msgMapping1 == null) {
            if (
              (QueryStringValue2["type"] == 2 ||
                QueryStringValue2["type"] == 3) &&
              QueryStringValue2["StockOutTransTMId"] != 0
            ) {
              PrintCrystalReport(HiddenStockOutMasterId);
              SaveLoader.value = false;

              updatepop.value = true;
            } else if (
              (QueryStringValue2["type"] == 2 &&
                QueryStringValue2["StockOutTransTMId"] == 0) ||
              QueryStringValue2["type"] == 1 ||
              (QueryStringValue2["type"] == 3 &&
                QueryStringValue2["StockTransId"] != 0)
            ) {
              PrintCrystalReport(HiddenStockOutMasterId);
              SaveLoader.value = false;

              successpop.value = true;
              ExportSendMail();
            }
          }
        }
      } else {
        SaveLoader.value = false;

        // toast.add({
        //   severity: "warn",
        //   summary: "Please Add the Item",
        //   detail: "",
        //   life: 3000,
        // });
      }
    }
    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      setupHistoryManagement(router, 2);

      // router.push({
      //     path: "/StoreTabDetails",
      //     query: {
      //         status: props.requestForm.status,
      //         Id: props.requestForm.fromStoreId,
      //         Type: props.requestForm.Types,
      //     },
      // });
    }

    const ParameterValues = ref({ Id: 0 });
    const PrintType = ref({ Type: "S", FormId: 10, ModuleId: 3 });

    function PrintCrystalReport(Id) {
      debugger;
      CrystalReportPopup.value = true;
      ParameterValues.value.Id = Id;
    }

    //Category List Tab Click Function
    const selectTab = (Type) => {
      // selectedTab.value = true;
      debugger;
      if (Type == "all") {
        ReadyItemList.value = ReadyListOrg.value;
        selectedTab.value = [];
        selectedTab.value.push("all");
      } else {
        let arr1 = selectedTab.value.find((i1) => i1 == Type);
        if (!arr1) {
          selectedTab.value = selectedTab.value.filter((i1) => i1 != "all");
          selectedTab.value.push(Type);
          ReadyItemList.value = ReadyListOrg.value.filter((item) =>
            selectedTab.value.includes(item.PickedBy)
          );
        } else {
          selectedTab.value = selectedTab.value.filter((i1) => i1 != Type);
          ReadyItemList.value = ReadyListOrg.value.filter((item) =>
            selectedTab.value.includes(item.PickedBy)
          );
        }
      }
    };
    //Ckeck the User Selection
    function CheckUser(value) {
      debugger;
      let arr = selectedTab.value.find((i1) => i1 == value);
      if (arr) return true;
      else return false;
    }
    //Confirm and Proceed / Ready For Delivery Click
    const nextPage = async () => {
      try {
        if (readyForDelivery.value === false) {
          CheckConfirm();
        } else {
          SubmitFunc();
        }
      } catch (error) {
        console.log(error);
      }
    };
    //Confirm & Proceed Changes
    async function ConfirmProceed() {
      await UpdatePicks(3, 3, 0);
      readyForDelivery.value = true;
      DataObj.value.ConfirmModel = false;
      btnName.value = "Ready for Delivery";
      const result = await WithoutStockService.GetPickListByRequestId(
        props.requestForm.StockWOTransTMId,
        HospitalId,
        QueryStringValue2["BranchId"]
      );
      debugger;
      console.log(result["result"]);
      ReadyItemList.value = result["result"]
        .filter((item) => item.PickStatus == 3)
        .map((i1) => {
          i1.ApprovedQty = i1.ItemQuantity;
          return i1;
        });
      ReadyListOrg.value = ReadyItemList.value;
      UserList.value = ReadyItemList.value.reduce((acc: any, current) => {
        const { PickedBy, PickedByName }: any = current;
        const existingCategory: any = acc.find(
          (item) => item["PickedBy"] == PickedBy
        );
        if (existingCategory) {
          existingCategory.count++;
        } else {
          acc.push({
            PickedBy,
            PickedByName,
            count: 1,
            ShortName: PickedByName.substring(0, 2),
          });
        }
        return acc;
      }, []);
    }
    //Update Picks
    async function UpdatePicks(PickStatus, Type, IsReadyItemList) {
      debugger;
      let arr: any = [];
      let PickTime = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
      let ScannedProduct =
        IsReadyItemList == 1
          ? ReadyItemList.value
          : // : selectedProduct.value.filter((i1) => i1.IsScanned == 1);
          selectedProduct.value.filter((i1) => i1.IsScanned > 0);
      for (let i = 0; i < ScannedProduct.length; i++) {
        let obj: any = {};
        obj.PickTime = PickTime;
        obj.PickStatus = PickStatus;
        obj.Type = Type;
        obj.ItemId = Number(ScannedProduct[i].ItemId);
        obj.BarCodeNo = Number(ScannedProduct[i].BarCodeNo);
        obj.BarCode = ScannedProduct[i].BarCode || "";
        obj.StockWoDetailsId = Number(ScannedProduct[i].StockDetailsId);
        obj.PickedBy = UserId;
        obj.PickQuantity = IsReadyItemList == 1 ? Number(ScannedProduct[i].PickQuantity) : Number(ScannedProduct[i].ScanQty);
        obj.PickReason = String(ScannedProduct[i].PickReason);
        obj.Remarks = String(ScannedProduct[i].Remarks);
        arr[i] = obj;
      }

      const result = await WithoutStockService.UpdatePickStatus(arr);
      debugger;
      console.log(result);
    }

    const ItemData: any = ref({});
    let ItemEditFlag = ref(false);
    //On Scan --this function is triggered
    async function onScanEnter() {
      debugger
      try {
        let Barcode: any = 0;
        let BarcodeNo: any = "";
        if (DataObj.value.ScanActive == "activebarcodebg") {
          // Barcode =
          //   IsUpdate.value == 1
          //     ? DataObj.value.BarCode
          //     : DataObj.value.ScanActive == "activebarcodebg"
          //       ? DataObj.value.Item
          //       : DataObj.value.Item["value"];
          const index = selectedProduct.value?.findIndex(
            (item: any) =>
              item.BarCode === DataObj.value.Item ||
              item.SupplierBarCode === DataObj.value.Item
          );
          Barcode =
            index !== -1 ? selectedProduct.value[index]["BarCodeNo"] : 0;
          BarcodeNo =
            index !== -1 ? selectedProduct.value[index]["BarCode"] : 0;

          const found = selectedProduct.value.find(
            (data: any) =>
              data["BarCodeNo"] === Barcode &&
              data["IsScanned"] === 2 &&
              ItemEditFlag.value == false
          );
          if (found) {
            toast.add({
              severity: "warn",
              summary: "This barcode has already been scanned completely.",
              detail: "",
              life: 3000,
            });
            ClearForm();

            return;
          }
        } else {
          debugger;
          DataObj.value.Item;
          const index = DataObj.value.ItemOption?.findIndex(
            (item: any) =>
              item.Name === DataObj.value.Item.split('/')[0].trim() ||
              item.SupplierBarCode === DataObj.value.Item
          );
          Barcode =
            index !== -1 ? DataObj.value.ItemOption[index]["BarCodeNo"] : 0;
        }

        let UOMId =
          selectedProductOrg.value.find(
            (item) => item.BarCodeNo == String(Barcode)
          )?.UOM || 0;

        let Id = 0;
        if (QueryStringValue2["type"] == 3) {
          Id = QueryStringValue2["StockTransId"];
        } else {
          Id = QueryStringValue2["StockWOTransTMId"];
        }
        const data_response = await Itemservice.GetByBarCodeId(
          props.requestForm.fromStoreId,
          Barcode,
          HospitalId,
          QueryStringValue2["BranchId"],
          UOMId,
          Id
        );

        if (data_response["result"].length == 0) {
          toast.add({
            severity: "warn",
            summary: "Item Not Found",
            detail: "Barcode not found in the system: " + DataObj.value.Item,
            life: 3000,
          });
          DataObj.value.Item = "";
          DataObj.value.AvailableQuantity = 0;
          DataObj.value.ScanQty = 0;
          return false;
        }

        console.log(data_response);
        DataObj.value.AvailableQuantity =
          data_response["result"][0]["StockInHand"];
        DataObj.value.BarCode = Barcode;
        DataObj.value.Item =
          data_response["result"][0]["ItemName"] +
          "-" +
          data_response["result"][0]["BarCode"];
        ItemData.value = data_response["result"][0];
        let ArrCount: any = selectedProductOrg.value.filter(
          (item) => item.ItemId == ItemData.value.Id
        );
        if (ArrCount.length > 0) {
          let ArrCount1: any = selectedProductOrg.value.filter(
            (item) =>
              item.ItemId == ItemData.value.Id &&
              item.BarCodeNo == DataObj.value.BarCode
          );
          if (ArrCount1.length == 0) {
            let ScanQty = selectedProduct.value
              .filter((i1) => i1.IsScanned > 0)
              .reduce((acc, cur) => Number(cur.ScanQty) + Number(acc), 0);
            let PickQty = selectedProduct.value.reduce(
              (acc, cur) => Number(cur.PickQuantity) + Number(acc),
              0
            );
            let qty = Number(PickQty) - Number(ScanQty);
            debugger;
            if (DataObj.value.AvailableQuantity >= qty) {
              DataObj.value.PickQuantity = qty;
            } else {
              DataObj.value.PickQuantity = DataObj.value.AvailableQuantity;
            }
          } else {
            DataObj.value.PickQuantity = ArrCount1[0].PickQuantity;
          }
          if (IsUpdate.value !== 1) {
            DataObj.value.ScanQty = DataObj.value.Checked ? 1 : 0;
          }

          // Disable Item Name field and focus Scan Qty field
          if (DataObj.value.Checked == false) {
            DataObj.value.ItemNameDisabled = true;

            // Focus the Scan Qty field
            setTimeout(() => {
              const scanQtyField = document.getElementById('ScanQty');
              if (scanQtyField) {
                scanQtyField.focus();
              }
            }, 100);
          }

          // Auto-call AddItems if DataObj.Checked is true
          if (DataObj.value.Checked) {
            // Small delay to ensure all data binding is complete
            setTimeout(() => {
              AddItems();
            }, 100);
          }

        } else {
          toast.add({
            severity: "warn",
            summary: "Item Does not Present in the Picked List",
            detail: "",
            life: 3000,
          });
          DataObj.value.Item = "";
          DataObj.value.AvailableQuantity = 0;
          DataObj.value.ScanQty = 0;
          return false;
        }

      } catch (error) {
        console.log(error);
      }
    }

    //Verify Barcodes
    const AddItems = handleSubmit(async (values, { resetForm }) => {
      debugger;

      if (DataObj.value.ScanQty == "" || DataObj.value.ScanQty == 0) {
        toast.add({
          severity: "warn",
          summary: "Please Enter Scan Quantity",
          detail: "",
          life: 3000,
        });
        return false;
      }

      if (IsUpdate.value == 1) {
        AddItemBtnName.value = "Add";
        IsUpdate.value = 0;
      } else {
        AddItemBtnName.value = "Add";
      }
      DiscrepancyItem.value = [];
      let ArrCount: any = selectedProduct.value.filter(
        (item) => item.ItemId == ItemData.value.Id
      );
      let ArrCountOrg: any = JSON.parse(
        JSON.stringify(
          selectedProductOrg.value.filter(
            (item) => item.ItemId == ItemData.value.Id
          )
        )
      );
      let ArrCountBar: any = selectedProduct.value.filter(
        (item) => item.BarCodeNo == DataObj.value.BarCode
      );
      let PickQuantityCount = 0;
      let ScanQuantityCount = 0;
      let IsScannedQuantityCount = 0;
      if (ArrCountBar.length > 0) {
        PickQuantityCount = ArrCount.filter(
          (i1) => i1.BarCodeNo != DataObj.value.BarCode
        ).reduce((acc, cur) => Number(cur.PickQuantity) + Number(acc), 0);
        ScanQuantityCount = ArrCountBar.reduce(
          (acc, cur) => Number(cur.ScanQty) + Number(acc),
          0
        );
      } else {
        PickQuantityCount = ArrCount.filter((i1) => i1.IsScanned > 0).reduce(
          (acc, cur) => Number(cur.PickQuantity) + Number(acc),
          0
        );
      }
      IsScannedQuantityCount = ArrCount.filter((i1) => i1.IsScanned > 0).reduce(
        (acc, cur) => Number(cur.PickQuantity) + Number(acc),
        0
      );
      let PickQuantityOrg = ArrCountOrg.reduce(
        (acc, cur) => Number(cur.PickQuantity) + Number(acc),
        0
      );
      // let chkPickQrg = selectedProductOrg.value.filter(
      //   (item) =>
      //     item.ItemId == ItemData.value.Id &&
      //     item.BarCodeNo == DataObj.value.BarCode
      // );
      // if (
      //   Number(chkPickQrg) > Number(DataObj.value.ScanQty) &&
      //   !DataObj.value.AddConfirm
      // ) {
      //   DataObj.value.AddConfirm = true;
      //   return false;
      // }
      // if(ArrCount.length !==  ArrCountOrg.length){
      //   if (Number(DataObj.value.ScanQty)  + Number(ScanQuantityCount) + Number(IsScannedQuantityCount) >
      //   Number(PickQuantityOrg)){
      //     toast.add({
      //     severity: "warn",
      //     summary: "Quantity Exceeds Pick Quantity",
      //     detail: "",
      //     life: 3000,
      //   });
      //   DataObj.value.ScanQty = 0;
      //   return false;
      //   }
      // }
      // else
      if (
        Number(DataObj.value.ScanQty) +
        Number(PickQuantityCount) +
        Number(ScanQuantityCount) >
        Number(PickQuantityOrg) ||
        Number(DataObj.value.ScanQty) > Number(PickQuantityOrg)
      ) {
        toast.add({
          severity: "warn",
          summary: "Quantity Exceeds Pick Quantity",
          detail: "",
          life: 3000,
        });
        DataObj.value.ScanQty = 0;
        return false;
      } else if (ArrCountBar.length > 0) {
        selectedProduct.value = selectedProduct.value.map((item) => {
          if (item.BarCodeNo == ArrCountBar[0].BarCodeNo) {
            item.PickQuantity = Number(DataObj.value.PickQuantity);
            item.ScanQty =
              Number(item.ScanQty || 0) + Number(DataObj.value.ScanQty);
            item.IsScanned =
              item.ScanQty === item.PickQuantity ? 2 : item.ScanQty > 0 ? 1 : 0;
          }
          return item;
        });
        //ClearForm();
      } else {
        let obj = ArrCountOrg[0];
        let arr1: any = [];
        arr1.push(obj);

        DiscrepancyItem.value = arr1.map((item) => {
          item.BarCodeNo = DataObj.value.BarCode;
          item.AvailableQuantity = DataObj.value.AvailableQuantity;
          item.PickQuantity = 0;
          item.ScanQty = DataObj.value.ScanQty;
          item.Room = ItemData.value.RoomId;
          item.RoomName = ItemData.value.RoomName;
          item.Rack = ItemData.value.RackId;
          item.RackName = ItemData.value.RackName;
          item.Row = ItemData.value.RowId;
          item.RowName = ItemData.value.RowName;
          item.ExpiryDate = ItemData.value.ExpiryDate;
          item.ApprovedQty = 0;
          item.ItemName = ItemData.value.ItemName;
          item.StockInHand = DataObj.value.AvailableQuantity;
          item.IsScanned =
            item.ScanQty === item.PickQuantity ? 2 : item.ScanQty > 0 ? 1 : 0;
          return item;
        });
        pickedItem.value = ArrCount;
        DataObj.value.EditModel = true;
      }

      //resetForm();
      ClearForm();
    });

    function IsItemDelete(data) {
      if (data.IsScanned == 1) {
        toast.add({
          severity: "warn",
          summary: "Barcode Scanned Already.Can't Delete",
          detail: "",
          life: 3000,
        });
        return false;
      } else {
        selectedProduct.value = selectedProduct.value.filter(
          (i1) => i1.BarCodeNo != data.BarCodeNo
        );
        toast.add({
          severity: "success",
          summary: "Deleted Successfully",
          detail: "",
          life: 3000,
        });
      }
    }

    let IsUpdate = ref(0);
    function IsItemEdit(data) {
      IsUpdate.value = 1;
      AddItemBtnName.value = t("btn.update");
      DataObj.value.PickQuantity = data.PickQuantity;
      DataObj.value.AvailableQuantity = data.StockInHand;
      ItemData.value.Id = data.ItemId;
      DataObj.value.BarCode = data.BarCode;
      DataObj.value.ScanQty = data.ScanQty;
      DataObj.value.Item = data.BarCode;
      ItemEditFlag.value = true;
      onScanEnter();
      ItemEditFlag.value = false;
    }

    function ConfirmIssue() {
      selectedProduct.value = [
        ...selectedProduct.value,
        ...DiscrepancyItem.value,
      ];
      DataObj.value.EditModel = false;
      ClearForm();
    }
    function ClearForm() {
      DataObj.value.Item = "";
      DataObj.value.ItemOption = [];
      DataObj.value.AvailableQuantity = ref();
      DataObj.value.PickQuantity = ref();
      DataObj.value.ScanQty = "";
      DataObj.value.AddConfirm = false;
      DataObj.value.ItemNameDisabled = false; // Re-enable the Item Name field
      // Focus the Item Name field after re-enabling it
      setTimeout(() => {
        const itemNameField = document.getElementById('Item');
        if (itemNameField) {
          itemNameField.focus();
        }
      }, 100);
      resetForm();

    }

    function onCheckedChange() {
      debugger;
      setTimeout(() => {
        const itemNameField = document.getElementById('Item');
        if (itemNameField) {
          itemNameField.focus();
        }
      }, 100);
    }

    //Check Confirm & Proceeed-If there is any item not scanned
    function CheckConfirm() {
      debugger;
      let arr = selectedProduct.value.filter((item) => item.IsScanned == 0);
      let arrscan = groupById(
        selectedProduct.value.filter((item) => item.IsScanned == 1)
      );
      let scanorg = selectedProductOrg.value.filter((item) => {
        let arrs = selectedProduct.value.find(
          (i1) => i1.BarCodeNo == item.BarCodeNo && i1.IsScanned == 1
        );
        return arrs != null;
      });
      let arrorg = groupById(scanorg);
      let scanitempending: any = [];
      console.log(arrscan);
      console.log(arrorg);
      for (var id in arrscan) {
        if (Number(arrorg[id]) > Number(arrscan[id])) {
          let filProduct = selectedProduct.value.filter(
            (i1) => i1.ItemId == id
          );

          let filObj = {
            ItemName: filProduct[0].ItemName,
            PickQuantity: Number(arrorg[id]) - Number(arrscan[id]),
            RoomName: "",
            RackName: "",
            BoxName: "",
            RowName: "",
          };
          scanitempending.push(filObj);
        }
      }

      if (arr.length > 0) {
        confirmItem.value = [...arr, ...scanitempending];
        DataObj.value.ConfirmModel = true;
      } else {
        ConfirmProceed();
      }
    }
    //Group Array and Sum the Items
    function groupById(arr) {
      return arr.reduce((acc, item) => {
        if (acc[item.ItemId]) {
          acc[item.ItemId] =
            Number(acc[item.ItemId]) + Number(item.PickQuantity);
        } else {
          acc[item.ItemId] = Number(item.PickQuantity);
        }
        return acc;
      }, {});
    }

    let QueryStringValue: any = route.query;
    QueryStringValue = JSON.parse(QueryStringValue.data);

    //Load Item
    async function LoadItem() {
      debugger;
      const dataresponse = await Itemservice.GetItemByStoresId(
        props.requestForm.fromStoreId,
        props.requestForm.toStoreId,
        DataObj.value.Item,
        1,
        0,
        QueryStringValue["ToStoreBrMapId"],
        QueryStringValue["FromStoreBrMapId"],
        HospitalId
        // ,
        // props.requestForm.StockWOTransTMId
      );

      if (dataresponse["result"].length > 0) {
        if (IsAdmin == 1) {
          DataObj.value.ItemOption = dataresponse["result"]
            .filter(item => {
              const match = selectedProduct.value.find(
                data => data["ItemId"] == item["Id"]
              );

              if (match) {
                const isBarcodeScanned = selectedProduct.value.some(
                  data => data["BarCodeNo"] == item["BarCodeNo"] && data.IsScanned == 2
                );
                return !isBarcodeScanned;
              }
              return false;
            })
            .map(item => ({
              ...item,
              label: item["Name"] + '/' + item["Batchno"] + '/' + item["ExpiryDate"],
              value: item["BarCodeNo"]
            }));

        } else {
          DataObj.value.ItemOption = dataresponse["result"]
            .filter((item) => {
              const data = selectedProduct.value.find(
                (data: any) =>
                  data["ItemId"] == item["Id"] &&
                  Number(data["BarCodeNo"]) == item["BarCodeNo"] && data.IsScanned != 2
              );
              return data != null; // Filter the items based on whether they have a matching ItemId in the props.isFilterData array
            })
            .map((item1: any) => {
              item1.label = item1["Name"];
              item1.value = item1["BarCodeNo"];
              return item1;
            });
        }
        // DataObj.value.ItemOption = DataObj.value.ItemOption.filter((item) => {
        //   const found = selectedProduct.value.find(
        //     (data: any) => Number(data["BarCodeNo"]) === item["BarCodeNo"]
        //   );
        //   return found !== undefined;
        // });
        debugger;
      }
    }
    function CheckAvaiQuantity() {
      if (
        Number(DataObj.value.ScanQty) > Number(DataObj.value.AvailableQuantity)
      ) {
        toast.add({
          severity: "warn",
          summary: "Quantity Exceeds Available Quantity",
          detail: "",
          life: 3000,
        });
        DataObj.value.ScanQty = 0;
        return false;
      }
    }
    async function ExportSendMail() {
      debugger;
      for (let i = 0; i < selectedProduct.value.length; i++) {
        selectedProduct.value[i].ExpiryDate = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        selectedProduct.value[i].CreatedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
      }
      try {
        debugger;
        let obj = {
          OrganizationId: HospitalId,
          BranchId: QueryStringValue2["BranchId"],
          requestId: selectedProduct.value[0].DocNo,
          ItemList: selectedProduct.value,
          StockWOTransTMId: selectedProduct.value[0].Id,
          BatchNo: selectedProduct.value[0].BatchNo,
        };

        const result = await WithoutStockService.ExportSendMailPickList(obj);
        if (result["result"] == "Success") {
          toast.add({
            severity: "success",
            summary: "Mail Sent Successfully",
            detail: "",
            life: 3000,
          });
        }
        console.log(result);
      } catch (error) {
        console.log(error);
      }
    }

    const Itemschanges = (value) => {
      debugger;
      if (value != "") {
        selectedProduct.value = [];
        selectedProduct.value = value;
      }
    };

    return {
      Itemschanges,
      ExportSendMail,
      CheckAvaiQuantity,
      LoadItem,
      ConfirmProceed,
      ConfirmIssue,
      DiscrepancyItem,
      pickedItem,
      DiscrepancyHeader,
      PickedHeader,
      IsItemDelete,
      IsItemEdit,
      IsUpdate,
      AddItemBtnName,
      AddItems,
      onScanEnter,
      nextPage,
      readyForDelivery,
      items,
      headers,
      globalFilterFields,
      filters,
      DataObj,
      successpop,
      updatepop,
      closetrigger,
      CrystalReportPopup,
      ParameterValues,
      PrintType,
      SubmitFunc,
      btnName,
      readyheaders,
      selectTab,
      selectedTab,
      selectedProduct,
      UserList,
      ReadyItemList,
      CheckUser,
      confirmItem,
      selectedProductOrg,
      SaveLoader,
      ItemEditFlag,
      ClearForm,
      onCheckedChange
    };
  },
});
</script>
<style lang="scss" scoped>
.nav-bar {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  box-shadow: 0 0 6px 3px rgba(0, 0, 0, 0.3);
  position: relative;
  z-index: 1;
}

.storeName {
  background-color: #e9e9e9;
  border-radius: 30px;
  width: fit-content;
  padding: 3px;
}

.main-header-store1 {
  background-color: #999999;
  font-size: 14px;
  border-radius: 50%;
  padding: 12px;
  margin-right: 4px;
  font-weight: 500;
  align-items: center;
  color: #ffffff;
  display: flex;
}

.storecode2 {
  color: #999999;
  font-size: 13px;
}

.selected {
  background-color: #3096ff !important;
}

.value {
  font-size: 13px;
  font-weight: 500;
}

.partial {
  background-color: orange;
  color: white;
  font-size: 10px !important;
  border-radius: 50%;
  margin-right: 5px;
  padding: 1px;
  height: 15px;
  width: 15px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.complete {
  background-color: green;
  color: white;
  font-size: 10px !important;
  border-radius: 50%;
  margin-right: 5px;
  padding: 1px;
  height: 15px;
  width: 15px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.barcodebg {
  border: 1px solid #999999;
  padding: 5px;
  margin: auto;
  margin-top: 30%;
  width: max-content;
}

.activebarcodebg {
  border: 2px solid blue;
  padding: 5px;
  margin: auto;
  margin-top: 30%;
  width: max-content;
}

.selectedcountbg {
  border: 1px solid #e1e1e1;
  padding: 5px;
  text-align: center;
  height: max-content;
  border-radius: 5px;

  .selectedcount {
    color: #3096ff;
    font-size: 18px;
    font-weight: 500;
  }

  .selectedtext {
    color: #999999;
    font-size: 14px;
  }
}

.itemdata-checked {
  height: 16px;
  width: 40px;
  position: absolute !important;
  top: 3px;
  right: 15px;
}

.itemdata-checked .p-inputswitch-slider:before {
  width: 0.75rem;
  height: 0.75rem;
  top: 11px;
}
</style>
